module.exports = __webpack_public_path__ + "img/BatResidentielR.86b56072.png";